__turbopack_context__.v({
  "badge": "o7655q_badge",
  "badgeDanger": "o7655q_badgeDanger",
  "badgeHighlight": "o7655q_badgeHighlight",
  "chip": "o7655q_chip",
  "chipList": "o7655q_chipList",
  "section": "o7655q_section",
  "sectionNote": "o7655q_sectionNote",
  "sectionTitle": "o7655q_sectionTitle",
});
